import React from 'react';

const SeasonalLights = ({ theme }) => {
  // Elegant, minimalist light configuration for all themes
  const lightCount = 15; // Weniger = edler
  
  // Edle Goldtöne für alle Themes
  const elegantGold = '#D4AF37'; // Elegantes Gold
  const softGold = '#E5C89F';    // Weiches Gold
  
  const lights = Array.from({ length: lightCount }, (_, i) => ({
    id: i,
    color: i % 2 === 0 ? elegantGold : softGold,
    delay: i * 0.3
  }));

  return (
    <div className="fixed top-0 left-0 w-full h-8 pointer-events-none z-50 overflow-hidden">
      {/* Elegante dünne Linie */}
      <div 
        className="absolute top-3 left-0 w-full h-px"
        style={{ 
          background: 'linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.2), transparent)'
        }} 
      />
      
      {/* Minimalistische Lichter */}
      <div className="relative w-full h-full flex justify-around items-start pt-2">
        {lights.map((light) => (
          <div
            key={light.id}
            className="relative"
            style={{
              animation: `elegantGlow 3s ease-in-out infinite`,
              animationDelay: `${light.delay}s`
            }}
          >
            {/* Kleine, elegante Punkte */}
            <div
              className="w-1.5 h-1.5 rounded-full"
              style={{
                background: light.color,
                boxShadow: `0 0 6px ${light.color}, 0 0 12px ${light.color}40`,
              }}
            />
          </div>
        ))}
      </div>

      <style>{`
        @keyframes elegantGlow {
          0%, 100% {
            opacity: 0.6;
            filter: brightness(1);
          }
          50% {
            opacity: 1;
            filter: brightness(1.3);
          }
        }
      `}</style>
    </div>
  );
};

export default SeasonalLights;
